import { languageTag } from "@/plugins/i18n";

// Pitch Coins (card 17trt6jd8uu). Coins nao sao dinheiro: quantidade com ate
// duas casas, sem "R$", no formato do idioma do Connect.
export function formatCoins(value, { signed = false } = {}) {
  const number = Number(value || 0);
  const text = new Intl.NumberFormat(languageTag(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Math.abs(number));
  if (number === 0) return text;
  if (signed) return number > 0 ? `+${text}` : `−${text}`;
  return number < 0 ? `−${text}` : text;
}

export function formatCoinDate(value, options) {
  if (!value) return "";
  return new Intl.DateTimeFormat(languageTag(), {
    timeZone: "America/Sao_Paulo",
    ...options,
  }).format(new Date(value));
}
